import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Card, Col, CardBody, Container } from 'reactstrap';
import Loader from "../Loader/Loader";
import RequestInfoAlert from '../Alert/RequestInfoAlert';
import RequestContext from '../../context/RequestContext';

function Content(props) {
  const { children, id } = props;
  const requestContext = useContext(RequestContext);

  const renderAlert = () => {
    const alertContent = requestContext.alertContent;

    if (alertContent?.visible) {
      const hasError = alertContent.hasError;
      const message = alertContent.message;
      const errorMessage = message
        ? 'Ocorreu um erro ao processar os dados!'
        : 'Ocorreu um erro fatal. Contate o Administrador.';
      const simpleMessage = !hasError ? 'Ação realizada com sucesso!' : errorMessage;
      const color = !hasError ? 'success' : message ? 'warning' : 'danger';

      window.scrollTo(0, 0);
      return (
        <RequestInfoAlert
          color={color}
          message={simpleMessage}
          hiddenMessage={message}
          expires={hasError && message ? 10000 : 4000} />
      );
    }

  };

  return (
    <Container id={id}>
      <Col xs="12">
        <Card>
          {requestContext.loading ? <Loader type='bars' /> : null}
          {renderAlert()}
          <CardBody>
            {children}
          </CardBody>
        </Card>
      </Col>
    </Container>
  );
}

Content.propTypes = {
  id: PropTypes.string,
};

export default Content;
